


export const CategoriesSection = () => (
  <div className="space-y-3">
    <div className="flex justify-between items-center">
      <h3 className="text-xs font-semibold uppercase text-muted-foreground">Categories</h3>
      <button className="text-xs text-primary hover:underline">+ Create</button>
    </div>
    <div className="text-sm text-muted-foreground">No categories yet.</div>
  </div>
);
